import { RootState } from 'src/redux/createRootReducer'

export const selectLoadingFromRemoteConfigState = (
  state: RootState,
): boolean | undefined => state.session.remoteConfig.loadingConfig

export const selectLoadedFromRemoteConfigState = (
  state: RootState,
): boolean | undefined => state.session.remoteConfig.loadedConfig

export const selectOrgIntegrationBetaOrgsFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.netSuiteOrgs

export const selectBmoIntegrationsWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.bmoIntegrationsWhitelist

export const selectQBDIntegrationsWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.qbdWhitelist

export const selectPushToWalletWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined => state.session.remoteConfig.pushToWalletWhitelist

export const selectAccountingStatsHeaderWhitelistFromRemoteConfigState = (
  state: RootState,
): string[] | undefined =>
  state.session.remoteConfig.accountingStatsHeaderWhitelist
